<template>
  <div
    style="display: flex;flex-direction: column;padding-bottom: 20px;width: 100%">
    <div style="height: 40px;width: 100%;display: flex;flex-direction: row;margin-bottom: 20px">
      <div style="width: 50%;display: flex;flex-direction: column;align-items: center;padding-top: 10px"
           @click="onTabClick(0)">
        <a style="color: #333333;font-size: 14px">付费课</a>
        <div :class="category === 1 ? 'tabTextLineSelected' : 'tabTextLine'"></div>
      </div>
      <div style="width: 50%;display: flex;flex-direction: column;align-items: center;padding-top: 10px"
           @click="onTabClick(1)">
        <a style="color: #333333;font-size: 14px">免费课</a>
        <div :class="category === 0 ? 'tabTextLineSelected' : 'tabTextLine'"></div>
      </div>
    </div>
    <div v-if="category === 1" style="display: flex;flex-direction: column;align-items: center">
      <el-row :gutter="20" style="margin-left: 10px;margin-right: 10px;">
        <el-col :span="(paidList.length < 4 ? 24 / paidList.length : 6)" v-for="(item, index) in paidList" :key="item.course_id">
          <el-card :body-style="{ padding: '0px' }" style="border-radius: 8px;margin-bottom: 20px">
            <div style="display: flex;flex-direction: column;align-items: center;justify-content: center">
              <img :src="item.course_cover" class="courseImg" @click="gotoVideoCourse(item.course_id)">
              <a class="courseTitle">{{ item.course_name }}</a>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <div>
        <el-button v-if="!paidPageComplete" type="primary" @click="menu">
          加载更多
          <i class="el-icon-arrow-down"></i>
        </el-button>
        <el-button v-if="paidPageComplete">已经到底部，没有更多课程啦~</el-button>
      </div>
    </div>
    <div v-if="category === 0" style="display: flex;flex-direction: column;align-items: center">
      <el-row :gutter="20" style="margin-left: 10px;margin-right: 10px">
        <el-col :span="(freeList.length < 4 ? 24 / freeList.length : 6)" v-for="(item, index) in freeList" :key="item.course_id">
          <el-card :body-style="{ padding: '0px' }" style="border-radius: 8px;margin-bottom: 20px">
            <div style="display: flex;flex-direction: column;align-items: center;justify-content: center">
              <img :src="item.course_cover" class="courseImg" @click="gotoVideoCourse(item.course_id)">
              <a class="courseTitle">{{ item.course_name }}</a>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <div>
        <el-button v-if="!freeLoadComplete" type="primary" @click="menu">
          加载更多
          <i class="el-icon-arrow-down"></i>
        </el-button>
        <el-button v-if="freeLoadComplete">已经到底部，没有更多课程啦~</el-button>
      </div>
    </div>
  </div>
</template>
<script>

import {api_my_course} from "../../networks/UserHandler.js"

export default {
  name: "personal-course-list",
  data() {
    return {
      category: 1,
      freeList: [],
      freePageStart: 1,
      freeLoadComplete: false,
      paidList: [],
      paidPageStart: 1,
      paidPageComplete: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  watch: {
    'user.user_id': {
      handler: function (val, oldVal) {
        this.updateRouteId();
      },
      deep: true
    }
  },
  mounted() {
    this.updateRouteId();
  },
  methods: {
    menu() {
      if (this.category === 1) {
        this.paidPageStart++;
      } else if (this.category === 0) {
        this.freePageStart++;
      }
      this.updateRouteId();
    },
    updateRouteId: function () {
      if (!this.user || !this.user.user_id || this.user.user_id === '') {
        return false;
      }
      var context = this;
      var pageNum = '';
      if (context.category === 1) {
        pageNum = context.paidPageStart;
      } else if (context.category === 0) {
        pageNum = context.freePageStart;
      }
      var promise = api_my_course(context.category, context.user.user_id, pageNum);
      promise.then(function (val) {
        context.newPage(val);
      }).catch(function (error) {
      });
    },
    newPage: function (val) {
      var _this = this;
      if (_this.category === 1) {
        if (val.paid_course_list.length === 0) {
          _this.paidPageComplete = true;
        } else {
          if (_this.paidPageStart < 2) {
            _this.paidList = val.paid_course_list;
          } else {
            _this.paidList = _this.paidList.concat(val.paid_course_list);
          }
        }
      } else if (this.category === 0) {
        if (val.free_course_list.length === 0) {
          _this.freeLoadComplete = true;
        } else {
          if (_this.freePageStart < 2) {
            _this.freeList = val.free_course_list;
          } else {
            _this.freeList = _this.freeList.concat(val.free_course_list);
          }
        }
      }
    },
    gotoVideoCourse(course_id) {
      this.$router.push({path: "/video/course_id/" + course_id})
    },
    onTabClick(index) {
      let _this = this;
      if (index === 1) {
        _this.category = 0;//免费
        if (_this.freeList.length === 0) {
          _this.updateRouteId();
        }
      } else if (index === 0) {
        _this.category = 1;//付费
      }
    }
  },
}
</script>

<style>

.tabTextLineSelected {
  height: 2px;
  width: 100%;
  background-color: #ffbc42;
  margin-top: auto;
}

.tabTextLine {
  height: 2px;
  width: 100%;
  background-color: #f2f2f2;
  margin-top: auto;
}

.courseImg {
  width: 100%;
  height: 125px;
}

.courseTitle {
  color: #333333;
  font-size: 14px;
  margin-top: 10px;
  font-weight: normal;
  margin-left: 10px;
  margin-right: 10px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/Personal/PersonalCourseList.vue